export * from './styles/icons-24/prizm-icons';
export * from './lib/icons-svg';
export * from './lib/icons';
export * from './lib/replace';
